import {
  CreateEscPosConnector,
  EscPosConnectorsApi,
  ListEscPosConnectors,
  OrdersApi,
  PrintPosReceiptForOrder,
  ResponseError,
  ShowEscPosConnector,
  ShowOrder1,
  UpdateEscPosConnector,
} from '@trybeapp/sdk'
import { useCurrentSiteId } from 'contexts/SiteConfig'
import { useMutation, useQuery, useQueryClient, UseQueryOptions } from 'react-query'
import { apiConfiguration } from 'utilities/TrybeApiClient'

const api = new EscPosConnectorsApi(apiConfiguration)
const ordersApi = new OrdersApi(apiConfiguration)

export const useEscPosConnectors = (
  options: UseQueryOptions<ListEscPosConnectors, ResponseError> = {}
) => {
  const siteId = useCurrentSiteId()

  return useQuery<ListEscPosConnectors, ResponseError>(
    ['escPosConnectors', { siteId }],
    () => api.listEscPosConnectors({ siteId }),
    options
  )
}

export const useCreateEscPosConnector = () => {
  const queryClient = useQueryClient()

  return useMutation<ShowEscPosConnector, ResponseError, CreateEscPosConnector>(
    (createEscPosConnector) =>
      api.createEscPosConnector({
        createEscPosConnector: {
          ...createEscPosConnector,
        },
      }),
    {
      onSuccess: (_, vars) => {
        queryClient.invalidateQueries(['escPosConnectors', { siteId: vars.site_id }])
      },
    }
  )
}

export const useUpdateEscPosConnector = () => {
  const queryClient = useQueryClient()

  return useMutation<ShowEscPosConnector, ResponseError, [string, UpdateEscPosConnector]>(
    ([id, updateEscPosConnector]) =>
      api.updateEscPosConnector({
        escPosConnector: id,
        updateEscPosConnector: {
          ...updateEscPosConnector,
        },
      }),
    {
      onSuccess: ({ data }) => {
        queryClient.invalidateQueries(['escPosConnectors', { siteId: data.site_id }])
      },
    }
  )
}

export const usePrintOrderReceipt = () => {
  return useMutation<ShowOrder1, ResponseError, [string, PrintPosReceiptForOrder]>(
    ([orderId, payload]) =>
      ordersApi.actionPrintPosReceiptForOrder({
        orderId,
        printPosReceiptForOrder: {
          ...payload,
        },
      })
  )
}

export const useDeleteEscPosConnector = () => {
  const queryClient = useQueryClient()

  return useMutation<void, ResponseError, string>(
    (id) => api.deleteEscPosConnector({ escPosConnector: id }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['escPosConnectors'])
      },
    }
  )
}
